import React, { useEffect, useState } from 'react'
import className from 'classnames/bind'
import { useHistory } from 'react-router'

import style from './MyhouseReviewDetailPage.module.scss'

import BlindContent from '@Components/VAC/common/BlindContent'
import MyhouseReviewDetailHeader from '@Components/atoms/MyhouseReviewDetailHeader'
import MyhouseReviewDetailContents from '@Components/atoms/MyhouseReviewDetailContents'
import MyhouseReviewDetailFooter from '@Components/atoms/MyhouseReviewDetailFooter'
import MyhouseReviewDetailTitle from '@Components/atoms/MyhouseReviewDetailTitle'
import useMyhouse from '@Hooks/myhouse/useMyhouse'
import useReview from '@Hooks/myhouse/review/useReview'
import { FETCH_STATUS } from '@Root/contants'
import { LAND_SERVICE_PREFIX_URL } from '@Root/contants/urlConstants'
import usePrevious from '@Hooks/common/usePrevious'
import Footer from '@Components/common/Footer'
import useBoard from '@Hooks/myhouse/board/useBoard'
import MyhouseCommonProgress from '@Components/atoms/MyhouseCommonProgress'
import { lcsSend } from '@Helpers/lcs'
import { NDS_PROTOCOL } from '@Root/contants/lcs'
import { getDeniedPath, LAND_DENIED_TYPE } from '@Root/contants/myhouseError'

const cx = className.bind(style)

const MyhouseReviewDetailPage: React.FC = () => {
  //변수선언부
  const { myhouse } = useMyhouse()
  const { complexNo } = myhouse
  const { loadReview, review, initializeReview } = useReview()
  const { setVisited, getNoticesReadableComplexNo } = useBoard()
  const detail = review?.detail

  const { sequence, fetchStatus, copyable, complexName } = detail
  const history = useHistory()
  const prevSequence = usePrevious(sequence)
  const [isShowLoading, setIsShowLoading] = useState(true)
  const [isOpened, setIsOpened] = useState(false)

  const headerProps = {
    title: (!getNoticesReadableComplexNo(complexNo) && complexName) || '입주민 리뷰',
  }

  //함수정의부
  const disableCopyHandler = (evt: React.SyntheticEvent) => {
    if (copyable) {
      return
    }

    evt.preventDefault()
    evt.stopPropagation()
  }

  //useEffect
  useEffect(() => {
    if (complexNo && sequence && (fetchStatus === FETCH_STATUS.INITIAL || prevSequence !== sequence)) {
      loadReview({ complexNo, reviewSequence: sequence })
      setIsOpened(false)
      setVisited(sequence)
    }
  }, [complexNo, sequence])

  useEffect(() => {
    lcsSend(NDS_PROTOCOL.MY_HOUSE.REVIEW.DETAIL)
    return () => {
      initializeReview()
    }
  }, [])

  useEffect(() => {
    if (fetchStatus === FETCH_STATUS.FAILURE) {
      if (history.action === 'POP') {
        history.replace(`${LAND_SERVICE_PREFIX_URL.MYHOUSE_COMPLEXES}/${complexNo}/reviews`)
        return
      }
      history.replace(getDeniedPath(LAND_DENIED_TYPE.BBS_LOAD_FAIL))
      return
    }

    if (fetchStatus === FETCH_STATUS.SUCCESS) {
      setIsShowLoading(false)
    }
  }, [fetchStatus])

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [detail])

  if (isShowLoading) {
    return <MyhouseCommonProgress isViewportHeight />
  }

  return (
    <>
      {fetchStatus === FETCH_STATUS.SUCCESS && (
        <>
          <MyhouseReviewDetailHeader {...headerProps} />
          <section
            id="content"
            className={cx('content_myhouse', 'type_resident', copyable ? '' : 'none_copy')}
            role="main"
            onContextMenu={disableCopyHandler}
            onCopy={disableCopyHandler}
          >
            <BlindContent />
            <div className={cx('content_resident_inner')}>
              <MyhouseReviewDetailTitle isOpened={isOpened} setIsOpened={setIsOpened} />
              <MyhouseReviewDetailContents />
            </div>
          </section>
          <MyhouseReviewDetailFooter />
          <Footer />
        </>
      )}
    </>
  )
}

export default MyhouseReviewDetailPage
